import { render } from "./BuyNewSIMCardService.vue?vue&type=template&id=4c685c5c"
import script from "./BuyNewSIMCardService.vue?vue&type=script&lang=js"
export * from "./BuyNewSIMCardService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__